var React = require('react');

function LightInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M12.686 46.146v5.924h25.67v-5.924a24.425 24.425 0 1 0-25.67.119v-.119ZM20.9 51.971l-3.494-23.338M30.24 51.971l3.515-23.338","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":0}),React.createElement("path",{"d":"m17.406 29.797 4.68 3.515 3.494-3.515 3.495 3.515 4.68-3.515M38.415 51.971h-25.67v7.01h25.67v-7.01Z","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":1}),React.createElement("path",{"d":"M36.085 58.98h-21.01v7.01h21.01v-7.01ZM33.755 65.99h-16.35V73h16.35v-7.01Z","stroke":"#004952","strokeWidth":"2","strokeMiterlimit":"10","key":2})]);
}

LightInline.defaultProps = {"width":"51","height":"74","fill":"none"};

module.exports = LightInline;

LightInline.default = LightInline;
